import { useState, useCallback, useEffect } from "react"
import { TypeAnimation } from 'react-type-animation';
import SearchInput from "../components/SearchInput"
import { searchMovies } from "../utils/apis/movies"
import CardMovies from "../components/CardMovies"
import Twitter from "../components/svg/Twitter";
import Fb from "../components/svg/Fb";
import CardMoviesSkeleton from "../components/skeletons/CardMovies";
import useDataClient from "../hooks/useDataClient";

const Movies = () => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [title, setTitle] = useState("")
    const [data, setData] = useState([])
    const [dataShow, setDataShow] = useState([])
    const [language, country] = useDataClient();

    const setValue = (value) => setTitle(value)

    const SearchTitles = useCallback(async () => {
        setLoading(true)
        const result = await searchMovies({
            title,
            language,
            country
        }, (e) => {
            setError(e)
            setLoading(false)
        })
        setLoading(false)
        setDataShow(result.slice(0, 6))
        setData(result.slice(6))
    }, [title,
        language,
        country])

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop ===
                document.documentElement.offsetHeight
            ) {
                setDataShow([...dataShow, ...data.slice(0, 4)])
                setData(data.slice(4))
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [data, dataShow]);
    if (error) {
        alert(error)
    }

    return (
        <div className="h-full">
            <div className="w-full container mx-auto">
                <div className="w-full flex items-center justify-between">
                    <a className=" font-serif flex items-center text-indigo-400 no-underline hover:no-underline font-bold text-2xl lg:text-4xl" href="/">
                        Hae<span className="bg-clip-text text-transparent bg-gradient-to-r from-green-400 via-pink-500 to-purple-500">sel</span>
                    </a>

                    <div className="flex w-1/2 justify-end content-center">
                        <a className="inline-block text-blue-300 no-underline hover:text-pink-500 hover:text-underline text-center h-10 p-2 md:h-auto md:p-4 transform hover:scale-125 duration-300 ease-in-out"
                            href="https://twitter.com/intent/tweet?url=#">
                            <Twitter />

                        </a>
                        <a
                            className="inline-block text-blue-300 no-underline hover:text-pink-500 hover:text-underline text-center h-10 p-2 md:h-auto md:p-4 transform hover:scale-125 duration-300 ease-in-out"
                            href="https://www.facebook.com/sharer/sharer.php?u=#"
                        >
                            <Fb />
                        </a>
                    </div>
                </div>
            </div>

            <div className="pt-24 mx-auto items-center">

                <div className="lg:w-4/6 md:w-full justify-center mx-auto">
                    <h1 className="text-3xl md:text-5xl text-white opacity-75 font-bold leading-tight text-center md:text-left">
                        Busca el mejor contenido!!
                        <TypeAnimation
                            sequence={[
                                'Peliculas...',
                                1000,
                                'Documentales...',
                                1000,
                                'Series...',
                                1000,
                                'Animes...',
                                1000,
                                'todo!!',
                                1000,
                            ]}
                            wrapper="span"
                            speed={50}
                            className="bg-clip-text text-transparen to-purple-500 px-1"
                            repeat={Infinity}
                        />
                    </h1>
                    <p className="leading-normal text-base md:text-2xl text-center md:text-left pb-4">
                        Verifica en que plataforma de streaming estan disponibles!
                    </p>
                    <SearchInput value={title} setValue={setValue} onPressEnter={SearchTitles} />
                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-2">
                        {!loading ? (
                            dataShow.map((data) =>
                                <CardMovies data={data} country={country} />
                            )
                        ) : (
                            [1, 2, 3, 4].map((id) =>
                                <CardMoviesSkeleton id={id} />
                            )

                        )}
                    </div>
                </div>

            </div>
        </div>)
}


export default Movies
